import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalPauseAlertComponent } from './modal-pause-alert/modal-pause-alert.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MatOption, MatSelect } from '@angular/material/select';
import { SourceDevicesDto } from '../../../interfaces/Responses/ISourceDevicesStatusResponse';
import { ModalSettingsCameraComponent } from './modal-settings-camera/modal-settings-camera.component';
import { exit } from 'process';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GridColumnsConfiguration, GridFilter, Gridsource, GridSourceItem } from '../../shared/grid/grid.component';
import { DialogYesnoComponent } from '../../shared/dialog-yesno/dialog-yesno.component';
import { DialogPauseAlertComponent } from './dialog-pause-alert/dialog-pause-alert.component';

@Component({
  selector: 'neoris-aisettings-camera-control',
  templateUrl: './aisettings-camera-control.component.html',
  styleUrl: './aisettings-camera-control.component.css'
})
export class AISettingsCameraControlComponent implements OnInit, AfterViewInit {

  /*---------------EVENT_TYPES------------------------*/
  eventTypeGridTitle: string = ""
  public eventTypesGridColumnsConfiguration: GridColumnsConfiguration = {
    ShowAddButton: true,
    IconValue: undefined,
    IconColumnName: undefined,
    hiddenColumnNames: ['id',
      'sourceDeviceId',
      // 'eventTypeId',
      'eventTypeName',
      'severityTypeId',
      'severityTypeName',
      'isActive',
      'pausedTo',
      'ROW_ID',
    'GRID_STATUS'],
    dateColumns: [],
    cardColum: "id",
    cardValues: [
      { place: 0, nombre: 'id', isMainColumn: false }
    ],
    listColumns: [
      'ROW_ID',
      'id',
      'sourceDeviceId',
      'eventTypeId',
      'eventTypeName',
      'severityTypeId',
      'severityTypeName',
      'isActive',
      'pausedTo',
      'actions'
    ],
    MultiIconColumns: [],
    ActionColumn: {
      ColumnName: "actions",
      Actions: [
        {
          Description: "Disable Alert",
          ShowDescription: true,
          IconUrl: "../assets/images/controlTowers/disable_button.svg",
          ActionName: "DisableAlert",
          States:
          {
            StateColumn: "isActive",
            Condition: "IS",
            StateValues: [
              {
                StateIcon: "../assets/images/controlTowers/enable_button.svg",
                StateValue: true
              },
              {
                StateIcon: "../assets/images/controlTowers/disable_button.svg",
                StateValue: false
              }
            ]
          }
        },
        {
          Description: "Pause Alert",
          ShowDescription: true,
          IconUrl: "../assets/images/controlTowers/pause-alert.svg",
          ActionName: "PauseAlert",
          States:
          {
            StateColumn: "pausedTo",
            Condition: "NOT",
            StateValues: [
              {
                StateIcon: "../assets/images/controlTowers/resume.svg",
                StateValue: null
              }
            ]
          }
        },
        {
          Description: "Delete Alert",
          ShowDescription: true,
          IconUrl: "../assets/images/controlTowers/delete-icon.svg",
          ActionName: "DelteAlert"
        }
      ]
    }
  }

  dataEventTypes: any[] = []

  private currentEventTypeCell: number = -1
  public async EventTypesCellClick(obj: any) {
    // console.log("obj", obj)
    if (obj.ACTION !== undefined) {
      if (obj.ACTION.ActionName == "DelteAlert") {

        let message = "";
        switch(this.lang){
          case "es":
            message = "¿Deseas eliminar el registro?"
            break;
          case "en":
            message = "Are you sure you want to delete the record?"
            break;
        }

        const dialogRef = this.dialog.open(DialogYesnoComponent, {
          data: {
            text: message
          }
        });

        dialogRef.afterClosed().subscribe(resultado => {

          resultado = resultado ?? false
          if (resultado == true) {

            this.DialogDeleteEventTypes(obj)

          } else {
            // El usuario canceló o cerró el diálogo
            console.log('Cancelado o cerrado');
          }
        });


      }

      if (obj.GRID_STATUS !== "NEW") {

        if (obj.ACTION.ActionName == "PauseAlert") {

          console.log("EventTypesCellClick", obj)
          if ((obj.pausedTo ?? null) !== null) {
            this.ResumeAlertDialog(obj)
          } else {
            this.PauseAlertDialog(obj)
          }
        }

        if (obj.ACTION.ActionName == "DisableAlert") {

          this.DisableEnableAlertDialog(obj, obj.isActive)

        }

      }


    }

    if (obj.GRID_STATUS !== "NEW") {
      if (this.currentEventTypeCell !== obj.ROW_ID)
        this.GetSourceDeviceAlertNotificationByAlertId(obj.id)
    }
    else {
      this.dataContactos = []
    }

    this.currentEventTypeCell = obj.ROW_ID

    this.contactosGridTitle = this.eventTypeGridTitle + " - " + obj.eventTypeName


  }

  public async EventTypesAddClick(obj: any) {
    let maxId = 0

    if (this.dataEventTypes.length > 0) {
      maxId = this.dataEventTypes.reduce((prev, current) => {
        return current.id > prev.id ? current : prev;
      }).id;
    }

    let dataEventTypes = [...this.dataEventTypes]; // copia superficial

    //Obtener Site/Client
    // currentCameraCell
    var camera = this.cameras.find(f => f.id === this.currentCameraCell)

    dataEventTypes.push({
      ROW_ID: maxId + 1,
      id: maxId + 1,
      sourceDeviceId: camera.id,
      eventTypeId: -1,
      eventTypeName: "",
      severityTypeId: -1,
      severityTypeName: "",
      isActive: true,
      pausedTo: null,
      actions: "",
      GRID_STATUS: 'NEW'
    })

    this.dataEventTypes = dataEventTypes
  }

  public async EventTypesSaveChanges(obj: any) {
    //Validaciones
    var sinEventType = obj.filter(f => f.eventTypeId === -1)

    // var sinContacto = obj.filter(f => f.ContactId == -1);
    // var sinNotificationConfiguration = obj.filter(f => f.NotificationConfigurationId == -1);

    if (sinEventType.length > 0) {

      let message = "";
      switch(this.lang){
        case "es":
          message = "No se puede guardar, existe información sin seleccionar, por favor revise."
          break;
        case "en":
          message = "Cannot save. Some required information is missing, please review."
          break;
      }

      this.openSnackBar(message, "error")
      return
    }

    var updatedAndNewItems = obj.filter(f => f.GRID_STATUS !== "")

    var mapedItems = updatedAndNewItems.map(m => {
      m.severityTypeId = m.severityTypeId == -1 ? null : m.severityTypeId
      m.DTO_STATUS = m.GRID_STATUS == "CHANGED" ? "UPDATE" : m.GRID_STATUS
      return m;
    });

    await this.SaveSourceDeviceAlert(mapedItems)
    await this.getCameraInfo(this.currentCameraCell)
  }

  private PauseAlertDialog(obj: any) {

    let message = "";
    switch(this.lang){
      case "es":
        message = 'Pausar ' + obj.eventTypeName + ' para ' + this.eventTypeGridTitle
        break;
      case "en":
        message = 'Pause ' + obj.eventTypeName + ' for ' + this.eventTypeGridTitle
        break;
    }


    const dialogRef = this.dialog.open(DialogPauseAlertComponent, {
      data: {
        text: message,
        deviceAlertId: obj.id,
        selectedHour: '00',
        selectedMinute: '00'
      }
    });

    dialogRef.afterClosed().subscribe(resultado => {

      if (resultado.Paused !== undefined) {
        if (resultado.Paused) {
          this.ResumePauseAlert(resultado.Id, resultado.PausedTo)
        }
      }
    })
  }

  private DisableEnableAlertDialog(obj: any, active: boolean) {

    let message = ""
    if (active == false) {


      switch(this.lang){
        case "es":
          message = '¿Deseas activar la alerta para este tipo?'
          break;
        case "en":
          message = "Do you want to activate the alert for this type?"
          break;
      }


    } else {
      // message = '¿Deseas desactivar la alerta para este tipo?'

      switch(this.lang){
        case "es":
          message = '¿Deseas desactivar la alerta para este tipo?'
          break;
        case "en":
          message = "Do you want to disable the alert for this type?"
          break;
      }
    }

    const dialogRef = this.dialog.open(DialogYesnoComponent, {
      data: {
        text: message
      }
    });

    dialogRef.afterClosed().subscribe(resultado => {

      resultado = resultado ?? false
      if (resultado == true) {

        this.ActiveDesactiveAlert(obj.id, !active)

      } else {
        // El usuario canceló o cerró el diálogo
        console.log('Cancelado o cerrado');
      }
    });

  }

  private ResumeAlertDialog(obj: any) {

      let message = "";
      switch(this.lang){
        case "es":
          message = "¿Deseas reanudar la alerta para este tipo?"
          break;
        case "en":
          message = "Do you want to resume the alert for this type?"
          break;
      }

    const dialogRef = this.dialog.open(DialogYesnoComponent, {
      data: {
        text: message
      }
    });

    dialogRef.afterClosed().subscribe(resultado => {

      resultado = resultado ?? false
      if (resultado == true) {

        this.ResumePauseAlert(obj.id, null)

      } else {
        // El usuario canceló o cerró el diálogo
        console.log('Cancelado o cerrado');
      }
    });

  }

  private async ActiveDesactiveAlert(id: number, active: boolean) {

    let eventType = this.dataEventTypes.find(f => f.id == id)

    let newEventType = { ...eventType }

    newEventType.isActive = active
    newEventType.DTO_STATUS = "UPDATE"

    await this.SaveSourceDeviceAlert([newEventType])
    await this.getCameraInfo(this.currentCameraCell)
  }

  private async ResumePauseAlert(id: number, pausedTo: any) {

    let eventType = this.dataEventTypes.find(f => f.id == id)

    let newEventType = { ...eventType }

    newEventType.pausedTo = pausedTo
    newEventType.DTO_STATUS = "UPDATE"

    await this.SaveSourceDeviceAlert([newEventType])
    await this.getCameraInfo(this.currentCameraCell)
  }

  private async SaveSourceDeviceAlert(request: any): Promise<any> {

    console.log("SaveSourceDeviceAlert", request)
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveSourceDeviceAlert(request).subscribe(
        {
          next: (report: any) => {
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async DeleteSourceDeviceAlert(Id: any): Promise<any> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.DeleteSourceDeviceAlerts(Id).subscribe(
        {
          next: (report: any) => {
            resolve(true);
          }, error: (error) => {

            var _error = error.error;
            
            if (_error.message == "No se puede borrar, notificaciones asociadas") {

              let message = "";
              switch(this.lang){
                case "es":
                  message = "No se puede borrar, existen notificaciones asociadas"
                  break;
                case "en":
                  message = "You can't delete this record because it is associated with existing notifications"
                  break;
              }


              this.openSnackBar(message, "error")
            } else {
              this.openSnackBar(_error.message, "error")
            }

            resolve(false);
          }
        }
      )
    });
  }

  /*---------------CONTACTOS------------------------*/
  contactosGridTitle: string = ""
  public contactosGridColumnsConfiguration: GridColumnsConfiguration = {
    ShowAddButton: true,
    IconValue: undefined,
    IconColumnName: undefined,
    hiddenColumnNames: [
      'ROW_ID',
      'Id',
      'ContactId',
      // 'ContactName',
      'ContactEmail',
      'ContactWhatsapp',
      'AlertScheduleId',
      // 'AlertTypeId',
      'AlertTypeName',
      // 'NotificationConfigurationId',
      'NotificationConfigurationName',
      'NotificationGroupId',
      'SiteId',
      'ClientID',
      'GRID_STATUS',
      'SourceDeviceAlertId'],
    dateColumns: [],
    cardColum: "id",
    cardValues: [
      { place: 0, nombre: 'id', isMainColumn: false }
    ],
    listColumns: [
      'ROW_ID',
      'Id',
      'ContactId',
      'ContactName',
      'ContactEmail',
      'ContactWhatsapp',
      'AlertScheduleId',
      'AlertTypeId',
      'AlertTypeName',
      'NotificationConfigurationId',
      'NotificationConfigurationName',
      'NotificationGroupId',
      'SiteId',
      'ClientID',
      'actions'
    ],
    MultiIconColumns: [],
    ActionColumn: {
      ColumnName: "actions",
      Actions: [
        {
          Description: "Delete",
          ShowDescription: true,
          IconUrl: "../assets/images/controlTowers/delete-icon.svg",
          ActionName: "Delete"
        }
      ]
    }
  }

  dataContactos: any[] = []

  public async ContactosCellClick(obj: any) {

    // DeleteAlertNotification
    if (obj.ACTION !== undefined) {
      if (obj.ACTION.ActionName == "Delete") {


           let message = "";
      switch(this.lang){
        case "es":
          message = "¿Deseas eliminar el registro?"
          break;
        case "en":
          message = "Do you want to delete the record?"
          break;
      }

        const dialogRef = this.dialog.open(DialogYesnoComponent, {
          data: {
            text: message
          }
        });

        dialogRef.afterClosed().subscribe(resultado => {

          resultado = resultado ?? false
          if (resultado == true) {

            this.DialogDeleteContactos(obj)

          } else {
            // El usuario canceló o cerró el diálogo
            console.log('Cancelado o cerrado');
          }
        });

      }
    }
  }

  public async ContactosAddClick(obj: any) {

    //Verificar el status del device alert
    let deviceAlert = this.dataEventTypes.find(f => f.id == this.currentEventTypeCell) ?? null


    console.log("deviceAlert", deviceAlert)
    if (deviceAlert !== null) {

      //Si si hay un evento seleccionado,
      //Verificamos si el evento es nuevo o ya está en bd

      if (deviceAlert.GRID_STATUS !== "NEW") {
        let maxId = 0

        if (this.dataContactos.length > 0) {
          maxId = this.dataContactos.reduce((prev, current) => {
            return current.Id > prev.Id ? current : prev;
          }).Id;
        }

        let dataContactos = [...this.dataContactos]; // copia superficial

        //Obtener Site/Client
        // currentCameraCell
        var camera = this.cameras.find(f => f.id === this.currentCameraCell)
        var sourceDeviceAlert = this.dataEventTypes.find(f => f.id == this.currentEventTypeCell)

        dataContactos.push({
          ROW_ID: maxId + 1,
          Id: maxId + 1,
          ContactId: -1,
          ContactName: "",
          ContactEmail: "",
          ContactWhatsapp: "",
          AlertScheduleId: -1,
          AlertTypeId: 0,
          AlertTypeName: "",
          NotificationConfigurationId: -1,
          NotificationConfigurationName: "",
          NotificationGroupId: -1,
          SiteId: camera.siteId,
          ClientID: camera.clientId,
          actions: "",
          SourceDeviceAlertId: sourceDeviceAlert.id,
          GRID_STATUS: 'NEW'
        })

        this.dataContactos = dataContactos
      } else {

        
        let message = "";
        switch(this.lang){
          case "es":
            message = "No se pueden agregar contactos, debe guardar primero el Evento"
            break;
          case "en":
            message = "You can't add contacts. You must save the event first"
            break;
        }


        this.openSnackBar(message, "Error")
      }
    } else {
       let message = "";
        switch(this.lang){
          case "es":
            message = "No se ha seleccionado Evento"
            break;
          case "en":
            message = "Please select an event"
            break;
        }
      this.openSnackBar(message, "Error")
    }
  }

  public async contactosSaveChanges(obj: any) {
    var sinContacto = obj.filter(f => f.ContactId == -1);
    var sinNotificationConfiguration = obj.filter(f => f.NotificationConfigurationId == -1);

    if (sinContacto.length > 0 || sinNotificationConfiguration > 0) {

       let message = "";
        switch(this.lang){
          case "es":
            message = "No se puede guardar, existe información sin seleccionar, por favor revise."
            break;
          case "en":
            message = "Cannot save. Some required information is missing, please review."
            break;
        }

      this.openSnackBar(message, "error")
      return
    }

    var updatedAndNewItems = obj.filter(f => f.GRID_STATUS !== "")

    var mapedItems = updatedAndNewItems.map(m => {
      m.AlertScheduleId = m.AlertScheduleId == -1 ? null : m.AlertScheduleId
      m.NotificationGroupId = m.NotificationGroupId == -1 ? null : m.NotificationGroupId
      m.DTO_STATUS = m.GRID_STATUS == "CHANGED" ? "UPDATE" : m.GRID_STATUS
      return m;
    });

    await this.SaveAlertNotification(mapedItems)
    await this.GetSourceDeviceAlertNotificationByAlertId(this.currentEventTypeCell)
  }

  private async SaveAlertNotification(request: any): Promise<any> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveAlertNotification(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:', report);

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async DeleteAlertNotification(AlertNotificationId: any, sourceDeviceAlertId: any): Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.DeleteAlertNotification(AlertNotificationId, sourceDeviceAlertId).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:', report);

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }
  /*-------GRID SOURCES---------------*/
  public contactosGridSource: Gridsource[]
  public eventTypesGridSource: Gridsource[] = []



  public gFilter: GridFilter[] = [];
  public cameras: Array<any> = []

  items: Array<number> = [];
  alertsEnabled: boolean = false;
  public image: any
  public isImage: boolean = false
  public arrayImages: any[] = []
  public arrayCodeSeverity: any[] = []
  private onLanChange: Subscription
  strTranslate: string
  request: any = {}
  arrayIncidentsTypes: any[] = []
  form: UntypedFormGroup;
  private onIsAllSitesSubscription: Subscription



  filters = new UntypedFormGroup({
    severityType: new UntypedFormControl('', Validators.required),
    incidentType: new UntypedFormControl('', Validators.required),

  });

  @ViewChild('selIncidentType') selIncidentType: MatSelect;
  @ViewChild('selSeverityType') selSeverityType: MatSelect;


  constructor(private route: Router,
    private dialog: MatDialog,
    private controltowerservice: ControltowerService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private _snackBar: MatSnackBar,
    private propertiesService: PropertiesTowers,
    private ngxloader: NgxUiLoaderService) {

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
    })

  }

  async DialogDeleteContactos(obj: any) {
    var result = true
    if (obj.GRID_STATUS !== "NEW") {
      result = await this.DeleteAlertNotification(obj.Id, this.currentEventTypeCell)
    }

    if (result) {
      await this.GetSourceDeviceAlertNotificationByAlertId(this.currentEventTypeCell)
    }
  }

  async DialogDeleteEventTypes(obj: any) {
    var result = true

    if (obj.GRID_STATUS !== "NEW") {
      result = await this.DeleteSourceDeviceAlert(obj.ROW_ID)
    }

    if (result) {
      this.dataEventTypes = this.dataEventTypes.filter(f => f.id !== obj.id)

      if (this.dataEventTypes.length > 0){
        this.currentEventTypeCell = this.dataEventTypes[0].id

        await this.GetSourceDeviceAlertNotificationByAlertId(this.dataEventTypes[0].id)
      }
    }
  }

  async getInfo() {
    console.log("GET INFO")
    this.cameras = []
    this.dataEventTypes = []
    this.dataContactos = []
    this.currentEventTypeCell = -1

    await this.GetSourceDevicesByType()
    //Show first camera image
    if (this.cameras.length > 0)
      await this.getCameraInfo(this.cameras[0].id)

    await this.GetEventTypes()
    await this.GetContactsBySite()
    await this.GetAlertTypes()
    await this.GetNotificationsConfiguration()
  }

  async getCameraInfo(cameraId: number) {
    await this.GetSourceDeviceAlertsBySourceDeviceId(cameraId);

    if (this.dataEventTypes.length > 0)
      await this.GetSourceDeviceAlertNotificationByAlertId(this.dataEventTypes[0].id)
  }

  private lang: string = "en";

  async ngOnInit(): Promise<void> {

    this.onIsAllSitesSubscription = this.propertiesService.IsSelectAllSites$.subscribe((value) => {
      this.getInfo()

      // if(this.fromStatusCCTV == true){
      //   let successDeviceManagement = this.getDevicesManagement('en',this.rowSelectedCctv.id)
      //   this.fromStatusCCTV  = false
      // }
      // else{
      //   let siteId = localStorage.getItem('site');
      //   let successDeviceManagement = this.getDevicesManagement('en', siteId)
      // }

    })

    this.getInfo()
  }

  ngAfterViewInit(): void {
  }

  private async GetSourceDevicesByType(): Promise<boolean> {
    let sourceDeviceTypeId: number = 500
    let sitesId: string = localStorage.getItem('site');

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetSourceDevicesByType(sourceDeviceTypeId, sitesId).subscribe(
        {
          next: (result: any = {}) => {

            this.cameras = result

            if (this.cameras.length > 0) {
              this.currentCameraCell = this.cameras[0].id
              this.eventTypeGridTitle = this.cameras[0].name
            }

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async GetSourceDeviceAlertsBySourceDeviceId(sourceDeviceId: number): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetSourceDeviceAlertsBySourceDeviceId(sourceDeviceId, this.lang).subscribe(
        {
          next: (result: any = {}) => {

            this.dataEventTypes = result.map(m => {

              m.ROW_ID = m.id
              m.id = m.id,
                m.sourceDeviceId = m.sourceDeviceId,
                m.eventTypeId = m.eventTypeId,
                m.eventTypeName = m.eventTypeName,
                m.severityTypeId = m.severityTypeId,
                m.severityTypeName = m.severityTypeName,
                m.isActive = m.isActive,
                m.pausedTo = m.pausedTo,
                m.actions = ""

              return m
            })

            let firstEventTypeName = "";

            if (this.dataEventTypes.length > 0) {
              this.currentEventTypeCell = this.dataEventTypes[0].id

              firstEventTypeName = this.dataEventTypes[0].eventTypeName
            }

            this.contactosGridTitle = this.eventTypeGridTitle + " - " + firstEventTypeName

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private alertMethods = [
    { id: 13203, name: 'EMAIL' },
    { id: 13204, name: 'WHATSAPP' },
    { id: 13206, name: 'STROBE SIREN' },
    { id: 13207, name: 'APP NOTIFICATION' },
    { id: 13205, name: 'SPEAKER' },
    { id: 13208, name: 'TEAMS' }
  ];

  private async GetSourceDeviceAlertNotificationByAlertId(SourceDeviceAlertId: number): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetSourceDeviceAlertNotificationByAlertId(SourceDeviceAlertId).subscribe(
        {
          next: (result: any = {}) => {

            this.dataContactos = result.map(m => {
              return {
                ROW_ID: m.id,
                Id: m.id,
                ContactId: m.contactId,
                ContactName: m.contactName,
                ContactEmail: m.contactEmail,
                ContactWhatsapp: m.contactWhatsapp,
                AlertScheduleId: null,
                AlertTypeId: m.alertTypeId,
                AlertTypeName: this.alertMethods.find(f => f.id == m.alertTypeId).name ?? "",
                NotificationConfigurationId: m.notificationConfigurationId,
                NotificationConfigurationName: m.notificationConfigurationName,
                NotificationGroupId: null,
                SiteId: m.siteId,
                ClientID: m.clientId,
                actions: "",
                GRID_STATUS: 'NONE',
                SourceDeviceAlertId: m.sourceDeviceAlertId,
              }
            });

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async GetContactsBySite(): Promise<boolean> {
    let sitesId: string = localStorage.getItem('site');

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetContactsBySite(sitesId).subscribe(
        {
          next: (result: any = {}) => {

            // result = result.map(m => {

            //   if(m.name == "Juan Pablo Mercol"){
            //     m.email = "juan@email.com"
            //     m.whatsapp = "2721310171"
            //   }

            //   return m;
            // })


            //Contactos
            var gridSources: Gridsource[] = []
            var contactosGridSource: GridSourceItem[] = []

            result.forEach(c => {
              contactosGridSource.push({
                Id: c.id,
                Description: c.name,
                ExtraDescription1: c.email,
                ExtraDescription2: c.whatsapp
              })
            });

            //  ContactEmail: "email@email.com",
            //     ContactWhatsapp: "522721310171",

            var gridSource: Gridsource = {
              SourceColumn: "ContactName",
              Configuration: {
                ValueColumn: "ContactId",
                DescriptionColumn: "ContactName",
                ExtraDescription1Column: "ContactEmail",
                ExtraDescription2Column: "ContactWhatsapp"
              },
              SourceItems: contactosGridSource
            }

            gridSources.push(gridSource)

            this.contactosGridSource = gridSources

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async GetAlertTypes(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetAlertTypes().subscribe(
        {
          next: (result: any = {}) => {

            console.log("result", result)

            let currentGridSource = [...this.contactosGridSource]

            var gridSource: Gridsource = {
              SourceColumn: "AlertTypeId",
              Configuration: {
                ValueColumn: "AlertTypeId",
                DescriptionColumn: "AlertTypeName"
              },

              SourceItems: result.map(m => {
                return {
                  Id: m.id,
                  Description: m.name
                }
              })
            }

            currentGridSource.push(gridSource)

            this.contactosGridSource = currentGridSource




            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async GetEventTypes(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetEventTypes(this.lang).subscribe(
        {
          next: (result: any = {}) => {

            console.log("GetEventTypes", result)

            let currentGridSource = [...this.eventTypesGridSource]

            var gridSource: Gridsource = {
              SourceColumn: "eventTypeId",
              Configuration: {
                ValueColumn: "eventTypeId",
                DescriptionColumn: "eventTypeName"
              },

              SourceItems: result.map(m => {
                return {
                  Id: m.id,
                  Description: m.name
                }
              })
            }

            currentGridSource.push(gridSource)

            this.eventTypesGridSource = currentGridSource

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async GetNotificationsConfiguration(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.GetNotificationsConfiguration().subscribe(
        {
          next: (result: any = {}) => {


            let currentGridSource = [...this.contactosGridSource]

            var gridSource: Gridsource = {
              SourceColumn: "NotificationConfigurationId",
              Configuration: {
                ValueColumn: "NotificationConfigurationId",
                DescriptionColumn: "NotificationConfigurationName"
              },

              SourceItems: result.map(m => {
                return {
                  Id: m.id,
                  Description: m.name
                }
              })
            }

            currentGridSource.push(gridSource)

            this.contactosGridSource = currentGridSource

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private currentCameraCell: number = -1

  public cameraClick(camera: any) {

    if (this.currentCameraCell !== camera.id) {
      this.dataEventTypes = []
      this.dataContactos = []
      this.currentEventTypeCell = -1


      this.eventTypeGridTitle = camera.name


      this.getCameraInfo(camera.id)
    }


    this.currentCameraCell = camera.id
  }























































  // toggleAllSelection(matSelect: MatSelect) {
  //   const isSelected: boolean = matSelect.options
  //     // The "Select All" item has the value 0, so find that one
  //     .filter((item: MatOption) => item.value === 0)
  //     // Get the value of the property 'selected' (this tells us whether "Select All" is selected or not)
  //     .map((item: MatOption) => item.selected)
  //   // Get the first element (there should only be 1 option with the value 0 in the select)
  //   [0];

  //   if (isSelected) {
  //     matSelect.options.forEach((item: MatOption) => item.select());
  //   } else {
  //     matSelect.options.forEach((item: MatOption) => item.deselect());
  //   }
  //   console.log('valor de matSelect:', matSelect)
  // }
  // async goToFormSettingsALert(sourceDeviceId: any) {

  //   console.log('form validators', this.filters.valid)

  //   /*if(this.filters.valid){
  //   let severity = this.filters.get('severityType').value
  //   let incidentType = this.filters.get('incidentType').value  
  //   console.log('severity',severity)

  //   this.request.sourceDeviceId = sourceDeviceId
  //   this.request.severityTypeId = severity
  //   this.request.eventTypeId = incidentType
  //   this.request.isActived = true

  //   console.log('request send',this.request)

  //   localStorage.setItem('sourceDeviceId', this.request.sourceDeviceId);
  //   let exito = await this.SaveConfigurationAlert(this.request);

  //   console.log('respuesta del servicio',exito)
  //   if(exito){
  //     console.log('respuesta del servicio',exito)
  //     this.openDialogCreateAlert()
  //   }
  // }
  // else{
  //   this.openSnackBar("Seleccione type Incident / Severity Type","FAILED")
  //   //this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")

  // }*/

  //   //this.openDialogCreateAlert()

  //   localStorage.setItem('sourceDeviceId', sourceDeviceId.toString());
  //   this.route.navigate(["/setting-camera"]);

  // }




  openSnackBar(message: string, action: string) {
    if (action == 'OK') {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar']
      });
    }
    else {
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['blue-snackbar-false']
      });
    }
  }

  // openDialogCreateAlert(): void {

  //   console.log('openDialog');

  //   this.dialog.open(ModalSettingsCameraComponent,
  //     {
  //       restoreFocus: false,
  //       width: '1000px',
  //       height: '800px'
  //     });


  // }


  // openDialog(sourceId: number): void {


  //   localStorage.setItem('sourceDeviceId', sourceId.toString());
  //   console.log('souceDeviceId', sourceId);

  //   this.dialog.open(ModalPauseAlertComponent,
  //     {
  //       restoreFocus: false,
  //       width: '600px',
  //       height: '600px'
  //     });


  // }




  // private async getGenericAtrributeValue(localCode: string): Promise<boolean> {


  //   return new Promise<boolean>((resolve, reject) => {
  //     this.controltowerservice.getAttributeValue(localCode).subscribe(
  //       {
  //         next: (attribute: any = {}) => {

  //           for (let i = 0; i <= attribute.attributeTypes.length - 1; i++) {
  //             console.log('si entre')
  //             if (attribute.attributeTypes[i].id == 8) {
  //               this.arrayCodeSeverity = attribute.attributeTypes[i].attributeValues

  //             }
  //           }

  //           console.log('this.arrayCodeSeverity', this.arrayCodeSeverity)


  //           resolve(true);
  //         }, error: (error: HttpErrorResponse) => {
  //           resolve(false);
  //         }
  //       }
  //     )
  //   });
  // }



  // private async SaveConfigurationAlert(request: any): Promise<any> {

  //   return new Promise<boolean>((resolve, reject) => {
  //     this.controltowerservice.SaveConfigurationAlert(request).subscribe(
  //       {
  //         next: (report: any) => {
  //           console.log('respondio el save reporte--->:', report);

  //           resolve(true);
  //         }, error: (error: HttpErrorResponse) => {
  //           resolve(false);
  //         }
  //       }
  //     )
  //   });
  // }

  // private async getDevicesManagement(lang: string, siteId: string): Promise<boolean> {

  //   return new Promise<boolean>((resolve, reject) => {
  //     this.controltowerservice.getDeviceManagement(lang, localStorage.getItem('site')).subscribe(
  //       {
  //         next: (arraydevices: any = {}) => {

  //           //console.log("arraydevices------>", arraydevices.sites)
  //           this.arrayImages = []
  //           arraydevices.sites.forEach((site: any) => {
  //             console.log("site------>", site.devices)

  //             site.devices.forEach((device: any) => {
  //               console.log("devices object------>", device)

  //               const byteArray = this.base64ToBytes(device.sourceDevice.url);

  //               console.log("byteArray------>", byteArray)
  //               this.isImage = device.sourceDevice.url.mediaType == 'image'
  //               let objectURL = `data:${device.sourceDevice.url.mediaType}/${device.sourceDevice.url.extension};base64,` + device.sourceDevice.url;
  //               this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  //               let sourceDeviceId = device.sourceDevice.id
  //               let name = device.sourceDevice.name

  //               if (device.deviceType.id == 500) {
  //                 this.arrayImages.push({ image: this.image, isImage: this.isImage, sourceDeviceId: sourceDeviceId, name: name });
  //               }
  //             });
  //           });



  //           resolve(true);
  //         }, error: (error: HttpErrorResponse) => {
  //           resolve(false);
  //         }

  //       }
  //     )
  //   });
  // }


  // private async getIncidentsTypes(): Promise<boolean> {


  //   return new Promise<boolean>((resolve, reject) => {
  //     this.controltowerservice.getIncidentsTypes(this.strTranslate).subscribe(
  //       {

  //         next: (incidentype: any) => {
  //           this.arrayIncidentsTypes = incidentype
  //           console.log('obtener values select--->', incidentype)
  //           resolve(true);
  //         }, error: (error: HttpErrorResponse) => {
  //           resolve(false);
  //         }
  //       }
  //     )
  //   });
  // }



  // base64ToBytes(base64: string): Uint8Array {
  //   // Decodificar la cadena Base64
  //   console.log('base64', base64)
  //   const binaryString = atob(base64);

  //   // Crear un array de bytes con la longitud de la cadena decodificada
  //   const bytes = new Uint8Array(binaryString.length);

  //   // Llenar el array de bytes con los valores de la cadena decodificada
  //   for (let i = 0; i < binaryString.length; i++) {
  //     bytes[i] = binaryString.charCodeAt(i);
  //   }

  //   return bytes;
  // }

}
